import type { Location } from "@finn-no/mobility-dealer-types";
import { Trans, useLingui } from "@lingui/react";
import { ElementType } from "@mobility-item-page/utilities/client";
import { AddressLink, GoogleMapsLink } from "./Links.tsx";

export const LocationSection = ({
  className = "",
  location,
  trackClick,
  showMap = true,
}: {
  className?: string;
  location: Location;
  trackClick: (elementType: ElementType, linkUrl?: string) => void;
  showMap?: boolean;
}) => {
  const { i18n } = useLingui();

  if (!location?.mapInfo && !location?.googleMapInfo) {
    return null;
  }

  return (
    <div className={`${className}`}>
      <h3 className="mb-16">
        <Trans id="dealer.dealerOverview.location" message="Visit us" />
      </h3>
      {location?.googleMapInfo ? (
        <GoogleMapsLink
          trackClick={(url: string) => trackClick(ElementType.Link, url)}
          mapInfo={location.googleMapInfo}
        />
      ) : (
        location.mapInfo && (
          <AddressLink
            mapInfo={location.mapInfo}
            trackClick={(elementType) => trackClick(elementType, location.mapInfo?.linkUrl)}
          >
            {showMap && location.mapInfo.imageUrl && (
              <img
                className="block rounded-8 mt-16 max-h-[400px]"
                src={location.mapInfo.imageUrl}
                alt={i18n.t({ id: "dealer.location.map", message: "Map showing the dealer location" })}
              />
            )}
          </AddressLink>
        )
      )}
    </div>
  );
};
